var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchipelagosLabsDevicesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000030448011026261469700000005480848133454628241_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,3.1c0.9,0,1.7,0.8,1.7,1.7v8.6c0,1-0.8,1.7-1.7,1.7c0,0,0,0,0,0h-6v2.6h2.6c0.5,0,0.9,0.4,0.9,0.8 c0,0,0,0,0,0v0.9H4.8v-0.9c0-0.5,0.4-0.9,0.9-0.9c0,0,0,0,0,0h2.6v-2.6h-6c-1,0-1.7-0.8-1.7-1.7V4.8c0-1,0.8-1.7,1.7-1.7 c0,0,0,0,0,0H16z M2.2,4.8H16v8.6H2.2V4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54,52.3c-7.6,0-13.8-6.2-13.8-13.8c0-7.6,6.2-13.8,13.8-13.8c7.6,0,13.8,6.2,13.8,13.8c0,0,0,0,0,0 C67.8,46.1,61.6,52.3,54,52.3z M54,54c-8.6,0-15.6-6.9-15.6-15.5s6.9-15.6,15.5-15.6c8.6,0,15.6,6.9,15.6,15.5c0,0,0,0,0,0 C69.5,47,62.5,54,54,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.1,47.9c-3.8,0-6.9-3.1-6.9-6.9s3.1-6.9,6.9-6.9S16,37.2,16,41S12.9,47.9,9.1,47.9L9.1,47.9z M9.1,49.7 c-4.8,0-8.6-3.9-8.6-8.6s3.9-8.6,8.6-8.6s8.6,3.9,8.6,8.6C17.7,45.8,13.9,49.7,9.1,49.7C9.1,49.7,9.1,49.7,9.1,49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.8,11.7c-1.4,0-2.6-1.2-2.6-2.6s1.2-2.6,2.6-2.6c1.4,0,2.6,1.2,2.6,2.6C57.4,10.5,56.3,11.7,54.8,11.7 C54.9,11.7,54.9,11.7,54.8,11.7z M54.8,13.4c-2.4,0-4.3-1.9-4.3-4.3s1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3S57.2,13.4,54.8,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22,22.9c-1.4,0-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6c1.4,0,2.6,1.2,2.6,2.6l0,0 C24.6,21.8,23.5,22.9,22,22.9z M22,24.6c-2.4,0-4.3-1.9-4.3-4.3S19.7,16,22,16s4.3,1.9,4.3,4.3S24.4,24.6,22,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.1,65.2c-1.4,0-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6c1.4,0,2.6,1.2,2.6,2.6C36.7,64,35.6,65.2,34.1,65.2 C34.1,65.2,34.1,65.2,34.1,65.2z M34.1,66.9c-2.4,0-4.3-1.9-4.3-4.3s1.9-4.3,4.3-4.3s4.3,1.9,4.3,4.3C38.4,65,36.5,66.9,34.1,66.9 C34.1,66.9,34.1,66.9,34.1,66.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10,21.2H8.2v12.1H10V21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.2,23.9l-1.4-1l-7.6,10.9l1.4,1L21.2,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.6,22.1l-0.9,1.5L41,33l0.9-1.5L25.6,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.5,41.4l0.2,1.7l22.6-2l-0.2-1.7L16.5,41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.1,18.7l0.6,1.6l26.1-10.2l-0.6-1.6L25.1,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.1,23.8l1.7,0.1l0.9-11.3L54,12.6L53.1,23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.8,59.7l1.4,1.1l8-10.4l-1.4-1.1L35.8,59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.9,62l1.1-1.3L14.4,46.5l-1.1,1.3L30.9,62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54,40.3c1,0,2,0.4,2.7,1.2c0.6,0.7,1.7-0.2,1.1-1c-1.9-2.1-5.1-2.2-7.2-0.3c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.6,0.7,0.5,1.7,1.1,1C52,40.7,53,40.3,54,40.3z M54,45.4c0.8,0,1.5-0.6,1.5-1.4c0-0.8-0.6-1.5-1.4-1.5c-0.8,0-1.5,0.6-1.5,1.4 c0,0,0,0,0,0C52.5,44.7,53.2,45.3,54,45.4z M54,36.6c1.9,0,3.7,0.7,5.1,2c0.6,0.6,1.7-0.3,1.1-1.1c-3.4-3.3-8.8-3.3-12.2,0 c-0.7,0.7,0.4,1.6,1.1,1.1c1.3-1.3,3.2-2.1,5.1-2.1L54,36.6z M54,33c2.7,0,5.4,1,7.4,2.9c0.7,0.7,1.7-0.4,1.1-1 c-4.7-4.4-12.1-4.4-16.8,0c-0.7,0.7,0.3,1.7,1,1C48.7,34,51.3,33,54,33L54,33z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchipelagosLabsDevicesIcon);
export default __webpack_public_path__ + "static/media/Archipelagos_Labs-DevicesIcon.84daf4ff858348786ae1ad079faf57a4.svg";
export { ForwardRef as ReactComponent };